
<template>
  <div>
    <v-dialog
      v-model="dialog"
      scrollable
      persistent :overlay="false"
      max-width="800px"
      transition="dialog-transition"
    >
      <template v-slot:activator="{ on, attrs }">
        <div class="d-flex">
          <v-spacer></v-spacer>
          <v-btn small color="primary" dark v-bind="attrs" v-on="on"><v-icon left>mdi-pencil</v-icon>Editar</v-btn>
        </div>
      </template>

      <v-card style="border-radius:12px">
        <v-card-title primary-title>
          <div class="headline mb-0">Editando contato</div>
        </v-card-title>
        <v-card-text>
          <address-form ref="form2" :address="address"></address-form>
        </v-card-text>
        <v-card-actions class="justify-end">
          <f-btn @click="cancelChanges" cancel></f-btn>
          <f-btn @click="saveInfo" save></f-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <dialog-loading loadingText="Salvando..." v-if="saving"></dialog-loading>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'DialogEditAddress',
  components: {
    AddressForm: () => import('@/_backoffice/_registrations/components/shared/forms/AddressForm.vue'),
  },
  data() {
    return {
      dialog: false,
      saving: false,
      address: {},
    }
  },
  mounted () {
    this.address = {...this.one_modality.address};
  },
  methods: {
    ...mapActions({
      saveAddress: 'Modality/saveAddress'
    }),
    cancelChanges() {
      this.address = {
        ...this.one_modality.address
      }
      this.dialog = false
    },

    saveInfo() {
      const validate = this.$refs.form2.validate()
      if (validate) {
        this.swallConfirmation({
          title: 'Deseja atualizar informações do galpão?',
          icon: 'question',
        }).then( confirmed =>{
          if ( confirmed ) {
            this.saving = true
            this.saveAddress({address: this.address, id: this.modality_id}).then(() => {
              this.dialog = false
            }).catch(err => {
              console.log(err)
            }).finally(() => {
              this.saving = false
            })
          }
        })
      }
    },
  },
  computed: {
    ...mapState({
      one_modality: state => state.Modality.one_modality
    })
  },
  watch: {
  },
}
</script>

<style scoped>

</style>
